export { useActiveProposal } from './useActiveProposal'
